import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.hideAdditionalFields();
    if (window.syncTractorTrailerUnitFields) {
      window.syncTractorTrailerUnitFields(this.element);
    }
  }

  toggleAdditionalFields(event) {
    const link = event.target;

    if (link.text == 'Show additional fields') {
      link.text = 'Hide additional fields';
      this.showAdditionalFields()
    } else {
      link.text = 'Show additional fields';
      this.hideAdditionalFields()
    }
  }

  hideAdditionalFields() {
    this.element.querySelectorAll("[data-additional='true']").forEach(function(el) {
      let input = el.querySelector('input');
      let select = el.querySelector('select');

      if (input) {
        if (!input.value.length) {
          el.style.display = 'none';
        }
      }

      if (select) {
        if (!select.value.length) {
          el.style.display = 'none';
        }
      }
    });
  }

  showAdditionalFields() {
    this.element.querySelectorAll("[data-additional='true']").forEach(function(el) {
      el.style.display = 'block';
    });
  }
}
